// AppSidebar.vue - Simplified
<template>
    <div class="layout-sidebar" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
        <div class="sidebar-header">
            <img src="@/assets/logo.png" alt="Logo" width="40" height="40" />
            <router-link :to="{ name: 'dashboard' }" class="app-logo">
            </router-link>
            <button class="layout-sidebar-anchor p-link z-2 mb-2" type="button" @click="anchor"></button>
        </div>
        <div class="layout-menu-container">
            <!-- Utilisation unique du nouveau composant simplifié -->
            <AppTieredMenuSimplified 
                :is-active="layoutState.sidebarActive.value" 
                :is-anchored="layoutState.anchored.value"
                @menu-click="onMenuClick" 
            />
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { onBeforeUnmount } from 'vue';
import AppTieredMenuSimplified from '@/layout/AppTieredMenuSimplified.vue';
import { useLayout } from '@/layout/composables/layout';

const { layoutState } = useLayout();

let timeout = null;

const onMouseEnter = () => {
    if (!layoutState.anchored.value) {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
        layoutState.sidebarActive.value = true;
    }
};

const onMenuClick = () => {
    if (!layoutState.anchored.value && window.innerWidth < 768) {
        layoutState.sidebarActive.value = false; // Rétracte la sidebar
    }
};
 
const onMouseLeave = () => {
    if (!layoutState.anchored.value) {
        if (!timeout) {
            timeout = setTimeout(() => {
                layoutState.sidebarActive.value = false;
            }, 300);
        }
    }
};

const anchor = () => {
    layoutState.anchored.value = !layoutState.anchored.value;
};

onBeforeUnmount(() => {
    if (timeout) {
        clearTimeout(timeout);
    }
});
</script>

<style lang="scss" scoped>
.layout-sidebar {
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    z-index: 999;
    overflow: visible;
    
    .layout-menu-container {
        overflow: visible;
    }
}
</style>